module.exports = __webpack_public_path__ + "static/media/tech-holistic-2.68f413c4.png";